import React, {useEffect, useState} from 'react';
import {Box, Grid, MenuItem, Typography} from '@mui/material';
import '../../styles/DashboardPage.css';
import {
    MyDashboardItemGray, MyDashboardItemGrayClickable, MyDashboardItemPropsColor,
    MyDashboardItemWhite,
    MyDashboardTypography, Orange, StyledButtonOrange
} from "../../styles/MyStyles";
import ClockDashboardItem from "./ClockDashboardItem";
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import ChecklistIcon from '@mui/icons-material/Checklist';
import PercentIcon from '@mui/icons-material/Percent';
import TuneIcon from '@mui/icons-material/Tune';
import ListAltIcon from '@mui/icons-material/ListAlt';
import NotificationsIcon from '@mui/icons-material/Notifications';
import {GetLookupValueName} from "../../logic/LookupHelper";
import {GetClients, GetManagerDashboard} from "../../logic/DataProvider";
import {GetClientViewName} from "../../logic/ClientNameHelper";
import dayjs from "dayjs";
import {GetEnumValueName} from "../../logic/EnumHelper";
import {useNavigate} from "react-router-dom";
import {GetNotificationTitle} from "../../logic/NotificationHelper";
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import {GetNotificationItemColor, UpdateNotificationState} from "../../logic/NotificationsHelper";
import * as MyStyles from "../../styles/MyStyles";
import {RememberTab} from "../../logic/ClientTabReminder";

const ManagerDashboard = () => {
    const navigate = useNavigate();
    const [dashboard, setDashboard] = useState();
    const [clients, setClients] = useState([]);

    useEffect(() => {
        GetClients().then((clients) => setClients(clients));

        if (!dashboard) {
            GetManagerDashboard(true).then((value) => setDashboard(value))
                .then((value) => GetManagerDashboard(false).then((value) => setDashboard(value)));
        }
    }, []);

    const readNotification = async (e, notificationId) => {
        e.stopPropagation();
        let success = await UpdateNotificationState(notificationId, 1);

        if (success) {
            let newArr = [];

            dashboard.notifications.forEach((elem) => {
                if (elem.id !== notificationId) {
                    newArr.push(elem);
                }
            });

            setDashboard({
                ...dashboard,
                'notifications': newArr
            });
        }
    };

    const orderDashboardItemClick = (e, order) => {
        e.stopPropagation();
        navigate(`/contacts/clients/${order.contactId}/order/${order.id}`);
    };

    const activeOrdersSectionClick = () => {
        navigate(`/active-orders`);
    };

    const lastTradesSectionClick = () => {
        navigate(`/last-trades`);
    };

    const notificationsSectionClick = () => {
        navigate(`/notifications`);
    };

    const tradeDashboardItemClick = (e, trade) => {
        e.stopPropagation();
        navigate(`/contacts/clients/${trade.contactId}/trade/${trade.id}`);
    };

    const notificationDashboardItemClick = (e, notification) => {
        e.stopPropagation();

        if (notification.type === 1 || notification.type === 2) {
            navigate(`/tickets/${notification.metaObj.Id}`);
        }
        if (notification.type === 3) {
            let clientId = notification.connectedContactId;
            RememberTab(clientId, 'chainalysis');
            navigate(`/contacts/clients/${clientId}`);
        }
    };

    const formatEur = (amount) => {
        return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'EUR' }).format(amount);
    };

    const getCommissionsEarnedBox = () => {
        if (dashboard?.commissionsEarned?.items !== null && dashboard?.commissionsEarned?.items?.length !== 0) {
            let gridSize = Math.floor(12/dashboard?.commissionsEarned?.items?.length);

            let items = [];

            for (const index in dashboard?.commissionsEarned?.items) {
                let item = dashboard?.commissionsEarned?.items[index];
                items.push(
                  <Grid key={item.assetId} item xs={gridSize}>
                      <MyDashboardTypography>{GetLookupValueName('asset', item.assetId)}</MyDashboardTypography>
                      <MyDashboardTypography>Monthly: {item.monthly}</MyDashboardTypography>
                      <MyDashboardTypography>Yearly: {item.yearly}</MyDashboardTypography>
                  </Grid>
                );
            }
            return items;
        }
        return (<Grid item xs={12}><MyDashboardTypography>You haven't earned anything yet.</MyDashboardTypography></Grid>);
    };

    return (
        <Box sx={{ flexGrow: 1, marginLeft: '50px', marginRight: '50px' }}>
            <Grid container spacing={2}>
                <Grid item xs={12} style={{ marginTop: '20px' }}>
                    <ClockDashboardItem/>
                </Grid>
                <Grid item xs={3}>
                    <MyDashboardItemGray style={{minHeight: '100px'}}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <b>Clients Active</b>
                            <RecentActorsIcon />
                        </div>
                        <MyDashboardTypography>Total: {dashboard?.clientsActive.total}</MyDashboardTypography>
                        <MyDashboardTypography>Individuals: {dashboard?.clientsActive.individuals}</MyDashboardTypography>
                        <MyDashboardTypography>Legal Entities: {dashboard?.clientsActive.legalEntities}</MyDashboardTypography>
                    </MyDashboardItemGray>
                </Grid>
                <Grid item xs={3}>
                    <MyDashboardItemGray style={{minHeight: '100px'}}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <b>Total Deals</b>
                            <ChecklistIcon />
                        </div>

                        <MyDashboardTypography>Monthly: {dashboard?.totalDeals.monthly}</MyDashboardTypography>
                        <MyDashboardTypography>Yearly: {dashboard?.totalDeals.yearly}</MyDashboardTypography>
                    </MyDashboardItemGray>
                </Grid>
                <Grid item xs={6}>
                    <MyDashboardItemGray style={{minHeight: '100px'}}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <b>Commissions Earned</b>
                            <PercentIcon />
                        </div>
                        <Grid container>
                            {getCommissionsEarnedBox()}
                        </Grid>
                    </MyDashboardItemGray>
                </Grid>
                <Grid item xs={3}>
                    <MyDashboardItemGrayClickable onClick={activeOrdersSectionClick}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                            <b>ACTIVE ORDERS</b>
                            <TuneIcon />
                        </div>
                        {dashboard && dashboard.activeOrders?.map((order) => (
                            <MyDashboardItemWhite key={order.id} onClick={(e) => orderDashboardItemClick(e, order)}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography style={{ color: Orange, fontWeight: 'bold' }}>
                                        {GetClientViewName(clients.find(e => e.id === order.contactId))}
                                    </Typography>
                                    <Typography>
                                        {GetEnumValueName('orderType', order.type)}
                                    </Typography>
                                </div>
                                <Typography style={{ marginTop: '10px', fontWeight: 'bold' }}>
                                    {GetLookupValueName('asset', order.sellAssetId)} -> {GetLookupValueName('asset', order.buyAssetId)}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography>
                                        {order.type === 0
                                            ? order.action === 1
                                                ? `${order.cryptoAmountRequested} -> ${order.requestedPrice * order.cryptoAmountRequested}`
                                                : `${order.requestedPrice * order.cryptoAmountRequested} -> ${order.cryptoAmountRequested}`
                                            : order.cryptoAmountRequested
                                        }
                                    </Typography>
                                    <Typography>
                                        {dayjs(order.createdDate).format(MyStyles.DateFormat)}
                                    </Typography>
                                </div>
                            </MyDashboardItemWhite>
                        ))}
                        {dashboard && (!dashboard.activeOrders || dashboard.activeOrders.length === 0) && (
                            <Typography style={{ marginTop: '10px' }}>
                                You have no active orders.
                            </Typography>
                        )}
                    </MyDashboardItemGrayClickable>
                </Grid>
                <Grid item xs={3}>
                    <MyDashboardItemGrayClickable onClick={lastTradesSectionClick}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                            <b>LAST TRADES</b>
                            <ListAltIcon />
                        </div>
                        {dashboard && dashboard.lastTrades?.map((trade) => (
                            <MyDashboardItemWhite key={trade.id} onClick={(e) => tradeDashboardItemClick(e, trade)}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography style={{ color: Orange, fontWeight: 'bold' }}>
                                        {GetClientViewName(clients.find(e => e.id === trade.contactId))}
                                    </Typography>
                                    <Typography>
                                        {clients.find(e => e.id === trade.contactId)?.dossierId}
                                    </Typography>
                                </div>
                                <Typography style={{ marginTop: '10px', fontWeight: 'bold' }}>
                                    {GetLookupValueName('asset', trade.sellAssetId)} -> {GetLookupValueName('asset', trade.buyAssetId)}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography>
                                        {trade.action === 1 ? `${trade.cryptoAmount} -> ${trade.amount}` : `${trade.amount} -> ${trade.cryptoAmount}`}
                                    </Typography>
                                    <Typography>
                                        {dayjs(trade.date).format(MyStyles.DateFormat)}
                                    </Typography>
                                </div>
                            </MyDashboardItemWhite>
                        ))}
                        {dashboard && (!dashboard.lastTrades || dashboard.lastTrades.length === 0) && (
                            <Typography style={{ marginTop: '10px' }}>
                                You have no trades.
                            </Typography>
                        )}
                    </MyDashboardItemGrayClickable>
                </Grid>
                <Grid item xs={6}>
                    <MyDashboardItemGrayClickable onClick={notificationsSectionClick}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                            <b>NOTIFICATIONS</b>
                            <NotificationsIcon />
                        </div>
                        {dashboard && dashboard.notifications?.map((notification) => (
                            <MyDashboardItemPropsColor color={GetNotificationItemColor(notification)} key={notification.id}
                                                  onClick={(e) => notificationDashboardItemClick(e, notification)}>

                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography style={{ color: Orange, fontWeight: 'bold' }}>
                                        {GetEnumValueName('internalNotificationType', notification.type)}
                                    </Typography>
                                    <StyledButtonOrange style={{ paddingTop: '2px', paddingBottom: '2px', paddingLeft: '10px', paddingRight: '10px', minWidth: '40px' }}
                                                        variant="contained" component="span"
                                                        onClick={(e) => readNotification(e, notification.id)}>
                                        <MarkEmailReadIcon fontSize={'small'}/>
                                    </StyledButtonOrange>
                                </div>
                                <Typography style={{ marginTop: '10px', fontWeight: 'bold' }}>
                                    {GetClientViewName(clients.find(e => e.id === notification.connectedContactId))}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography>
                                        {GetNotificationTitle(notification)}
                                    </Typography>
                                    <Typography>
                                        {dayjs(notification.date).format(MyStyles.DateFormat)}
                                    </Typography>
                                </div>
                            </MyDashboardItemPropsColor>
                        ))}
                        {dashboard && (!dashboard.notifications || dashboard.notifications.length === 0) && (
                            <Typography style={{ marginTop: '10px' }}>
                                You have no unread notifications.
                            </Typography>
                        )}
                    </MyDashboardItemGrayClickable>
                </Grid>
            </Grid>
        </Box>

    );
};

export default ManagerDashboard;




